<template>
  <div>
    <div class="row align-items-center">
      <div class="col-sm-9">
        <base-header>Loan Applications</base-header>
      </div>
      <div class="col-sm-3 text-right">
        <base-button class="mb-5" icon-right="plus" modal="#createProjectModal" secondary>
          New Loan Application
        </base-button>
      </div>
    </div>
    <p v-if="$auth.borrower()">
      Once the required borrower information has been complete you will be able to submit new loan
      applications in relation to your projects. Any existing applications and loans will be shown below.
    </p>
    <project-filter no-margin :refresh="$auth.admin()" />
    <create-project-modal />
  </div>
</template>

<script>
import CreateProjectModal from './CreateProjectModal.vue'
import ProjectFilter from './ProjectFilter.vue'

export default {
  name: 'LoanApplications',

  components: {
    CreateProjectModal,
    ProjectFilter
  }
}
</script>
